const ABFieldCalculateCore = require("../../core/dataFields/ABFieldCalculateCore");
module.exports = class ABFieldCalculate extends ABFieldCalculateCore {};
